'use strict';

var processInclude = require('theme/js/util');

jQuery(function () {
    processInclude(require('theme/js/plp-scroll-restore/plp-scroll-restore'));
});
